import { useNavigate } from "react-router-dom";
import XIcon from "../../../img/svg/xIcon";
import { formatPhoneNumber } from "../../../utils/functions";
import LoadingBalls from "../../core/loadingBalls";
import InstagramIcon from "../../../img/svg/instagramIcon";
import SiteIcon from "../../../img/svg/siteIcon";
import WhatsappIcon from "../../../img/svg/whatsappIcon";
import { useAuth } from "../../../context/authProvider";

export default function AdvertiserModal({ adv, loading, close, slug }: { adv: { [key: string]: string } | null; loading: boolean; close: () => void, slug: string | undefined }) {
    const { user } = useAuth();
    const navigate = useNavigate();
    const isBlocked = !user || !user?.emailVerified || !user?.termsAccepted?.accepted;

    return (
        <div onClick={close} className="fixed z-[150] inset-0 bg-primary/60 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto">
            <div onClick={e => e.stopPropagation()} className="w-full max-w-2xl bg-white rounded-[2rem] shadow-2xl overflow-hidden relative animate-superfade">
                <button
                    onClick={close}
                    className="absolute top-6 right-6 p-2 hover:bg-moninho rounded-full transition-colors z-20 group"
                >
                    <div className="group-hover:rotate-90 transition-transform">
                        <XIcon fill="#111827" />
                    </div>
                </button>

                <h1 className="bg-primary text-white text-center py-6 font-black tracking-[0.2em] text-sm uppercase">
                    CONTATO DO ANUNCIANTE
                </h1>

                <div className="p-8 md:p-12">
                    {
                        loading ?
                            <div className="flex justify-center py-12"><LoadingBalls /></div>
                            : !adv ?
                                <div className="text-center py-12 text-mono italic">
                                    Nenhuma informação disponível no momento.
                                </div>
                                :
                                <div className="relative">
                                    {isBlocked ?
                                        <div className="absolute inset-0 bg-white/40 backdrop-blur-md flex items-center justify-center z-10 p-6">
                                            <div className="text-center space-y-4 max-w-sm">
                                                <p className="font-bold text-primary leading-tight">
                                                    {
                                                        !user ? "AUTENTIQUE-SE PARA VER O ANUNCIANTE" :
                                                            !user?.emailVerified ? "CONFIRME SEU EMAIL" :
                                                                "ACEITE OS TERMOS DE USO"
                                                    }
                                                </p>
                                                <button
                                                    onClick={() => navigate(!user ? "/gatekeeper" : "/me", { state: { from: `/watches/${slug}` } })}
                                                    className="w-full bg-primary text-secondary font-black py-4 rounded-2xl hover:bg-primary/90 transition-all shadow-xl shadow-primary/20"
                                                >
                                                    {!user ? "ENTRAR AGORA" : "PROSSEGUIR"}
                                                </button>
                                            </div>
                                        </div>
                                        : null}

                                    <div className={`space-y-6 ${isBlocked ? "blur-sm pointer-events-none select-none opacity-30" : ""}`}>
                                        <div className="bg-moninho rounded-3xl p-6 md:p-8 space-y-6 divide-y divide-surface">
                                            <div className="flex flex-col md:flex-row justify-between gap-2 pb-4">
                                                <span className="text-xs font-black text-mono tracking-widest uppercase">Nome</span>
                                                <span className="font-bold text-primary text-lg">{adv?.name}</span>
                                            </div>

                                            <div className="flex flex-col md:flex-row justify-between gap-2 py-4">
                                                <span className="text-xs font-black text-mono tracking-widest uppercase">Email</span>
                                                <span className="font-medium text-primary break-all">{adv?.email}</span>
                                            </div>

                                            <div className="flex flex-col md:flex-row justify-between gap-2 pt-4">
                                                <span className="text-xs font-black text-mono tracking-widest uppercase">Telefone</span>
                                                <a
                                                    href={`https://wa.me/55${adv?.phoneNumber}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="font-bold text-secondary hover:underline text-lg"
                                                >
                                                    {formatPhoneNumber(adv?.phoneNumber)}
                                                </a>
                                            </div>
                                        </div>

                                        <div className="flex justify-center gap-6 py-4">
                                            {[
                                                { icon: <WhatsappIcon />, link: `https://wa.me/55${adv?.phoneNumber}`, active: !!adv?.phoneNumber },
                                                { icon: <InstagramIcon />, link: `https://instagram.com/${adv?.instagram}`, active: !!adv?.instagram },
                                                { icon: <SiteIcon />, link: adv?.site, active: !!adv?.site }
                                            ].map((social, idx) => (
                                                social.active && (
                                                    <a
                                                        key={idx}
                                                        href={social.link}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="w-14 h-14 bg-moninho rounded-full flex items-center justify-center hover:bg-secondary hover:text-white transition-all duration-300 shadow-sm"
                                                    >
                                                        {social.icon}
                                                    </a>
                                                )
                                            ))}
                                        </div>

                                        <button
                                            onClick={() => navigate(`/advertisers/${adv.slug}`)}
                                            className="w-full py-5 bg-white border-2 border-primary text-primary font-black tracking-[0.2em] text-xs rounded-2xl hover:bg-primary hover:text-white transition-all active:scale-95"
                                        >
                                            VER PERFIL COMPLETO
                                        </button>
                                    </div>
                                </div>
                    }
                </div>
            </div>
        </div>
    )
}
